import { createRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { Route as RootRoute } from './__root';

const SmlouvaProtokolEdit = lazy(() =>
  import('@/modules/ojeta-vozidla/SmlouvaProtokolEdit').then((m) => ({
    default: m.SmlouvaProtokolEdit,
  })),
);

export const Route = createRoute({
  getParentRoute: () => RootRoute,
  path: '/ojeta-vozidla/smlouvy/$id/protokol/upravit',
  component: () => (
    <Suspense fallback={null}>
      <SmlouvaProtokolEdit />
    </Suspense>
  ),
});
